import { getUserAgent, parseWechatLogin, parseQQLogin, getUrlSession } from '@tencent/midas-util'

/**
 * 获得页面 session 的值
 * QQ or Wx
 * 非 QQ/WX 跳微信授权
 * 提示用户在微信内打开
 */
export default function getSession(): any | null {
  const urlSession = getUrlSession()

  if (urlSession) {
    return urlSession
  }

  if (getUserAgent().QQ) {
    const loginState = parseQQLogin()

    if (loginState) {
      return loginState
    }
  } else {
    const loginState = parseWechatLogin()

    if (loginState) {
      return loginState
    }
  }
  return null
}
